// auth
export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_ERROR = 'REGISTER_ERROR'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const LOGOUT = 'LOGOUT'

// profile
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER'
export const SET_FAN_INBOX = 'SET_FAN_INBOX'
export const SET_ARTIST_INBOX = 'SET_ARTIST_INBOX'
export const SET_USER_DOB = 'SET_USER_DOB'
export const CACHE_PROFILE = 'CACHE_PROFILE'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js